import * as React from "react";
const SvgFiRrShirtTankTop = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M19.649 8.472A3.48 3.48 0 0 1 18 5.5V1a1 1 0 1 0-2 0v3c0 2.206-1.794 4-4 4S8 6.206 8 4V1a1 1 0 1 0-2 0v4.5a3.48 3.48 0 0 1-1.65 2.972C3.518 8.993 3 9.951 3 10.974V19c0 2.757 2.243 5 5 5h8c2.757 0 5-2.243 5-5v-8.026c0-1.023-.518-1.981-1.351-2.502M19 19c0 1.654-1.346 3-3 3H8c-1.654 0-3-1.346-3-3v-8.026c0-.339.157-.648.409-.806a5.5 5.5 0 0 0 2.035-2.274A5.99 5.99 0 0 0 12 10a5.98 5.98 0 0 0 4.556-2.106 5.5 5.5 0 0 0 2.034 2.274c.253.158.41.467.41.806z"
    />
  </svg>
);
export default SvgFiRrShirtTankTop;
